import { render } from "./RegisterEmailVerifyView.vue?vue&type=template&id=b0ef2f98"
import script from "./RegisterEmailVerifyView.vue?vue&type=script&lang=js"
export * from "./RegisterEmailVerifyView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__